<script>
/**
 * Advanced table component
 */
export default {
  data() {
    return {
      fields: [
        {
          key: 'name',
          sortable: true,
          label: 'نام',
          thStyle: { width: '180px' },
          filter: {
            component: 'SearchFilter',
            operator: '$lk',
            value: '',
          },
        },
        {
          key: 'lname',
          sortable: true,
          label: 'نام خانوادگی',
          thClass: 'd-none d-md-table-cell',
          tdClass: 'd-none d-md-table-cell',
          thStyle: { width: '180px' },
          filter: {
            component: 'SearchFilter',
            operator: '$lk',
            value: '',
          },
        },
        {
          key: 'email',
          sortable: true,
          label: 'ایمیل',
          thClass: 'd-none d-md-table-cell',
          tdClass: 'd-none d-md-table-cell',
          thStyle: { width: '180px' },
          filter: {
            component: 'SearchFilter',
            operator: '$lk',
            value: '',
          },
        },
        {
          key: 'phoneno',
          sortable: true,
          label: 'موبایل',
          thClass: 'd-none d-md-table-cell',
          tdClass: 'd-none d-md-table-cell',
          thStyle: { width: '180px' },
          filter: {
            component: 'SearchFilter',
            operator: '$lk',
            value: '',
          },
        },
      ],
    }
  },
}
</script>

<template>
  <crud-table
    create-route=""
    :columns="fields"
    vuex-prefix="developers"
    create-role="Admin"
    fetch-address="developers"
    hide-developer-column
  >
    <template #cell(actions)="data">
      <table-action-buttons
        fa-title="برنامه"
        permission="user"
        role="Admin"
        route="developers"
        :record-id="data.item.id"
        :delete-title="data.item.name"
        @deleted="data.itemDeleted(data.itemDeleted(data.item))"
        hidden-delete-button
        hidden-edit-button
      >
      </table-action-buttons>
    </template>
  </crud-table>
</template>
